module.exports = __webpack_public_path__ + "img/7. Dashboard_1.9e8467b3.jpg";